import { invoke } from "@tauri-apps/api/core"
import { isTauriRuntime } from "~/lib/platform/runtime"

// iOS keeps its launch screen (the logo) over the web view until the web splash
// (app/spa-loading-template.html — the same logo, same place) is actually on screen; this reports
// that, so the native overlay can go without a blank frame in between. See src-tauri/src/ios_splash.rs.
// Runs as early as the app code does; two animation frames make sure the splash has been painted,
// not just parsed. A no-op on every other platform.
export default defineNuxtPlugin(() => {
  if (!isTauriRuntime()) return
  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      invoke("hide_native_splash").catch(() => {})
    })
  })
})
